<template>
  <tbody v-if="this.note">
    <tr>
      <td>
        <div>
        {{ note.createdDate | formatDateMMDDYYYY  }}
        </div>
      </td>
      <td>
        <div>
          {{ mapNoteType(note.type) }}
        </div>
      </td>
      <td class="note-content">
        <div>
          {{ note.content }}
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faAngleDoubleRight } from '@fortawesome/pro-regular-svg-icons';

library.add(
  faAngleDoubleRight,
);

export default {
  props: {
    note: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      noteTypeOptions: [],
    };
  },
  created() {
    this.noteTypeOptions = [
      {
        code: 'ADMIN',
        description: 'Admin',
      },
      {
        code: 'GENERAL',
        description: 'General',
      },
    ];
  },
  methods: {
    mapNoteType(noteCode) {
      return this.noteTypeOptions.find(n => n.code === noteCode).description;
    },
  },
};
</script>

<style lang="sass" scoped>
  .note-content
    max-width: 150px
    word-wrap: break-word
</style>
